import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MdRefresh from 'react-icons/lib/md/refresh';
import MdWarning from 'react-icons/lib/md/warning';
import css from '../../styles/table/tableerror';

class TableError extends Component {
    static propTypes = {
        text: PropTypes.string.isRequired,
        height: PropTypes.number,
        onClick: PropTypes.func,
        reloading: PropTypes.bool,
    };

    static defaultProps = {
        height: 200,
        onClick: null,
        reloading: false,
    };

    render() {
        const { onClick, height, text, reloading } = this.props;
        const iconClass = [css.icon];

        if (onClick) {
            if (reloading) {
                iconClass.push(css.spinning);
            }

            return (
                <div className={css.container} style={{ height }}>
                    <button className={css.button} onClick={onClick}>
                        <MdRefresh className={iconClass.join(' ')} />
                        <span className={css.text}>{text}</span>
                    </button>
                </div>
            );
        }

        return (
            <div className={css.container} style={{ height }}>
                <div className={css.message}>
                    <MdWarning className={iconClass.join(' ')} />
                    <span className={css.text}>{text}</span>
                </div>
            </div>
        );
    }
}

export default TableError;



/** WEBPACK FOOTER **
 ** /src/shared/components/table/TableError.js
 **/